import Layout from '@/layout';
var performanceBonusRouter = {
  path: '/performanceBonus',
  component: Layout,
  redirect: '/performanceBonus/setting',
  name: 'PerformanceBonus',
  meta: {
    title: '业绩分红',
    icon: 'clipboard'
  },
  children: [{
    path: 'setting',
    component: function component() {
      return import('@/views/performanceBonus/setting/index');
    },
    name: 'performanceBonusSetting',
    meta: {
      title: '业绩分红设置',
      icon: ''
    }
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/performanceBonus/level/index');
    },
    name: 'performanceBonusLevel',
    meta: {
      title: '业绩分红等级',
      icon: ''
    }
  }, {
    path: 'level/add',
    component: function component() {
      return import('@/views/performanceBonus/level/form');
    },
    name: 'performanceBonusLevelAdd',
    meta: {
      title: '新增业绩分红等级',
      icon: '',
      hidden: true,
      activeMenu: '/performanceBonus/level'
    }
  }, {
    path: 'level/edit',
    component: function component() {
      return import('@/views/performanceBonus/level/form');
    },
    name: 'performanceBonusLevelEdit',
    meta: {
      title: '编辑业绩分红等级',
      icon: '',
      hidden: true,
      activeMenu: '/performanceBonus/level'
    }
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/performanceBonus/record/index');
    },
    name: 'performanceBonusRecord',
    meta: {
      title: '分红记录',
      icon: ''
    }
  }, {
    path: 'record/detail',
    component: function component() {
      return import('@/views/performanceBonus/record/detail');
    },
    name: 'performanceBonusRecordDetail',
    meta: {
      title: '分红明细',
      icon: '',
      hidden: true,
      activeMenu: '/performanceBonus/record'
    }
  }]
};
export default performanceBonusRouter;